// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-splitter-layout/lib/index.css
// module id = 801
// module chunks = 1